export default async function handleRequestHeaders(app, ctx) {
  const method = ctx.options.method?.toLowerCase() ?? "get";
  ctx.options.headers = {
    Accept: "application/json",
    ...ctx.options.headers
  };
  if (method === "put" && ctx.options.body instanceof FormData) {
    ctx.options.method = "POST";
    ctx.options.body.append("_method", "PUT");
  }
}
